import { createReducer } from "../../utils/reducer.utils";
import { initialState } from "../../store/state/initial.state";

export const directoryReducer = createReducer(initialState.directory, {});
